/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 * @author Michal Mlčoch <xmlcoc12@stud.fit.vutbr.cz>
 */

import React, {useEffect, useState} from 'react';
import {
    AppBar,
    Box,
    Button,
    ButtonGroup,
    Container,
    Divider,
    IconButton,
    Menu,
    MenuItem,
    Toolbar,
    Tooltip,
    Typography
} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import {Link, useMatch, useNavigate, useResolvedPath} from "react-router-dom";
import {useAuth} from "../data/userContext";
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import Avatar from '@mui/material/Avatar';
import Settings from '@mui/icons-material/Settings';
import ListItemIcon from '@mui/material/ListItemIcon';
import dataRoles from '../data/roles';
import CustomNavButton from "./CustomNavButton";


function Header(props) {
    const [menuOpen, setMenuOpen] = useState(null)

    const navigate = useNavigate();
    const auth = useAuth()
    const isLoggedIn = auth.user && auth.user.id !== 0;
    const pages = [
        {label: "Aukcie", link: '/'},
    ]
    if(isLoggedIn){
        pages.push({label: "Vytvoriť akciu", link: '/new-auction'});
        dataRoles.isLicitator(auth.user) && pages.push({label: "Schvalovaní aukcí", link: '/auctions-to-confirm'});
        dataRoles.isLicitator(auth.user) && pages.push({label: "Schvalovaní uživatelů", link: '/users-to-confirm'});
        dataRoles.isAdministrator(auth.user) && pages.push({label: "Správa uživatelů", link: '/admin/users'});
    }
    const handleOpenNavMenu = (event) => {
        setMenuOpen(event.currentTarget)
    }
    const handleCloseNavMenu = () => {
        setMenuOpen(null)
    }

    const logout = () => {
        auth.signout((res)=>{
            navigate('/');
        })
    }


    const [anchorElProfileMenu, setAnchorElProfileMenu] = React.useState(null);
    const openProfileMenu = Boolean(anchorElProfileMenu);

    const handleClickProfileMenu = (event) => {
        setAnchorElProfileMenu(event.currentTarget);
    };

    const handleCloseProfileMenu = () => {
        setAnchorElProfileMenu(null);
    };

    return (
        <AppBar position="static">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{mr: 2, display: {xs: 'none', md: 'flex'}}}
                    >
                        IS Aukcie
                    </Typography>

                    <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon/>
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={menuOpen}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(menuOpen)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: {xs: 'block', md: 'none'},
                            }}
                        >
                            {pages.map((page,i) => (
                                <MenuItem key={page.link} onClick={() => {navigate(page.link); handleCloseNavMenu()}} >
                                    {page.label}
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}
                    >
                        IS Aukcie
                    </Typography>
                    <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>
                        <ButtonGroup>
                        {pages.map((page,i) => (
                            <CustomNavButton
                                key={i}
                                variant={"contained"}
                                disableElevation
                                to={page.link}
                                onClick={() => {handleCloseNavMenu(); navigate(page.link);}}
                                sx={{my: 2, color: 'white', display: 'block'}}
                                >
                                {page.label}
                            </CustomNavButton>
                        ))}
                        </ButtonGroup>
                    </Box>

                    <Box sx={{flexGrow: 0}}>

                        { isLoggedIn ?<>
                            <Tooltip title="Profil">
                            <IconButton 
                                size="small" 
                                sx={{ ml: 2 }}
                                onClick={handleClickProfileMenu}
                                >
                                <Avatar sx={{ width: 32, height: 32 }}>{auth.user.name.toUpperCase()[0]}</Avatar>
                            </IconButton>
                            </Tooltip>
                            <Menu
                                anchorEl={anchorElProfileMenu}
                                open={openProfileMenu}
                                onClose={handleCloseProfileMenu}
                                onClick={handleCloseProfileMenu}
                                >
                                <MenuItem style={{pointerEvents: "none"}}>
                                    <Typography>{auth.user.name}</Typography>
                                </MenuItem>
                                <Divider />
                                <MenuItem
                                    onClick={() => navigate("/my-auctions")} 
                                    >
                                    Moje aukce
                                </MenuItem>
                                <Divider />
                                <MenuItem
                                    onClick={() => navigate("/profile")} 
                                    >
                                    <ListItemIcon>
                                        <Settings fontSize="small" />
                                    </ListItemIcon>
                                    Nastavení
                                </MenuItem>
                                <MenuItem
                                    onClick={logout}
                                    >
                                    <ListItemIcon>
                                        <LogoutIcon fontSize="small" />
                                    </ListItemIcon>
                                    Odhlásit se
                                </MenuItem>
                            </Menu>
                            </>
                            :
                            <Link to={'/login'} style={{textDecoration: "none"}}>
                                <Button
                                    variant="contained"
                                    color="warning"
                                    >
                                    <LoginIcon  sx={{marginRight: 1}}/>Přihlásit se
                                </Button>
                            </Link>
                        }

                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default Header;